import { itemStatusLabel } from '../../../shared/ui/Badge'
import type { RequestItemStatus } from '../../../shared/api/types'

interface HistoryEntry {
  id: string
  createdAt: string
  fromStatus?: string | null
  toStatus: string
  note?: string | null
  actor?: { email: string; name?: string | null } | null
}

export function ItemHistoryPanel({ history }: { history: HistoryEntry[] }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <h2 className="text-sm font-medium text-gray-700 mb-2">История</h2>
      {history.length === 0 ? (
        <p className="text-xs text-gray-400">Пусто</p>
      ) : (
        <div className="space-y-1">
          {history.map((h) => (
            <div key={h.id} className="flex items-center gap-3 text-xs">
              <span className="text-gray-300 shrink-0 w-28">
                {new Date(h.createdAt).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
              <span>
                {h.fromStatus ? (
                  <>
                    <span className="text-gray-400">
                      {itemStatusLabel(h.fromStatus as RequestItemStatus)}
                    </span>{' '}
                    →{' '}
                  </>
                ) : (
                  'Создана → '
                )}
                <span className="font-medium text-gray-700">
                  {itemStatusLabel(h.toStatus as RequestItemStatus)}
                </span>
              </span>
              {h.note && <span className="text-gray-400 truncate">· {h.note}</span>}
              <span className="text-gray-300 shrink-0 ml-auto">
                {h.actor?.name?.trim() || h.actor?.email}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
